import client from '@stores/apollo'
import gql from 'graphql-tag'
import { IImportProgress } from '@api'
import { ImportProgressFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  node: { status: string; progress: IImportProgress }
}
const mutateHandler = handleFetchResult<IPayload, { status: string; progress: IImportProgress }>({
  handler: (data) => data.node,
  name: 'Progress',
})

export default function progress(
  id: string
): Promise<{ status: string; progress: IImportProgress }> {
  return client.gql.query({ query, variables: { id } }).then(mutateHandler)
}

const query = gql`
  query bookingImportProgress($id: ID!) {
    node(id: $id) {
      ... on BookingImport {
        status
        progress {
          ...ImportProgressFragment
        }
      }
    }
  }
  ${ImportProgressFragment}
`
